import React from 'react'
import { InfoOutlined } from '@mui/icons-material'
import { reportError } from 'utils/errorReporter'
import NeowayProcessRow from '../NeowayProcessRow'

import ProcessRow from '../InovaProcessRow'

import styles from '../styles'

const BuildProcesses = (props) => {
  const { processData } = props
  const classes = styles()

  const renderProcessDataResume = () => {
    const showProcessConsists = (value, useColor = true) => {
      return value ? (
        <span style={{ color: useColor ? 'red' : null, fontWeight: useColor ? 'bold' : null }}>Sim</span>
      ) : (
        <span style={{ color: useColor ? 'green' : null, fontWeight: useColor ? 'bold' : null }}>Não</span>
      )
    }
    return (
      <React.Fragment>
        <h4>Resumo:</h4>
        <div className={classes.processResumeDiv}>
          <div>
            {'É réu em processo criminal: '}
            {showProcessConsists(processData.has_criminal_process)}
          </div>
          <div>
            {'É réu em processo de improbidade administrativa: '}
            {showProcessConsists(processData.has_administrative_improbity_process)}
          </div>
          <div>
            {'É réu em algum outro tipo de processo de menor criticidade: '}
            {showProcessConsists(processData.has_other_kind_process, false)}
          </div>
        </div>
      </React.Fragment>
    )
  }

  const renderProcessList = () => {
    const renderDisclaimer = () => {
      if (!processData.has_any_critical_process && processData.has_other_kind_process) {
        return (
          <i className={classes.disclaimerContent}>
            {' '}
            <InfoOutlined fontSize="small" /> Exibindo os processos judiciais de menor criticidade para fins
            informativos:
          </i>
        )
      }
      return null
    }

    try {
      const searchEngine = processData.search_engine

      return processData.has_any_process ? (
        <React.Fragment>
          {renderDisclaimer()}
          <ul style={{ listStyle: 'none', padding: 0, width: '100%' }}>
            {processData.process_courts.map((court) => {
              return searchEngine === 'INOVA_MOTOR' ? (
                <ProcessRow
                  key={`court:${court.uuid}`}
                  title={court.court_description}
                  otherInfos={court.service.data}
                />
              ) : (
                <NeowayProcessRow
                  key={`court:${court.uuid}`}
                  title={court.court_description}
                  processes={court.processes}
                />
              )
            })}
          </ul>
        </React.Fragment>
      ) : (
        <div className={classes.expansibleContent}>
          <span>Nenhum processo a ser exibido.</span>
        </div>
      )
    } catch (err) {
      reportError(err)
      return (
        <div className={classes.errorCaptured}>
          <span>Ocorreu um erro ao tratar os dados</span>
        </div>
      )
    }
  }

  return (
    <React.Fragment>
      {renderProcessDataResume()}
      {renderProcessList()}
    </React.Fragment>
  )
}

export default BuildProcesses
